<template>
  <div class="titleBar">
    <div class="titleBarBg" :style="{backgroundImage: finalHomeConfig.dailyTrophyMostBg ? `url(${finalHomeConfig.dailyTrophyMostBg})` : '', backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat', backgroundPosition: 'center center'}">
      <h3>{{ title }}</h3>
    </div>
  </div>
</template>

<script>
export default {
  name: "titleBar",
  props: {
    title: {
      type: String,
      default: "",
    },
    homeConfig:{
      type:Object,
      default:()=>{}
    }
  },
  computed: {
    finalHomeConfig() {
      // 如果props中有homeConfig且不为空对象，使用props中的homeConfig
      if (this.homeConfig && Object.keys(this.homeConfig).length > 0 && this.homeConfig.dailyTrophyMostBg) {
        return this.homeConfig;
      }
      // 否则从sessionStorage中获取
      const sessionConfig = sessionStorage.getItem('homeConfig');
      try {
        return sessionConfig ? JSON.parse(sessionConfig) : {};
      } catch (e) {
        console.warn('解析sessionStorage中的homeConfig失败:', e);
        return {};
      }
    }
  }
};
</script>

<style lang="less">
.titleBar {
  display: flex;
  position: relative;
  justify-content: center;
  
  .titleBarBg {
    width: 100%;
    height: 68px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  h3 {
    font-size: 34px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 56px;
    position: absolute;
    z-index: 3;
    right: 4px;
    top: 6px;
    width: 100%;
    text-align: center;
    margin: 0;
  }
  .redBar {
    position: relative;
    left: 28px;
    top: -4px;
  }
  .blueBar {
    position: relative;
    right: 28px;
    z-index: 2;
    opacity: 0.8;
  }
  .parallelogram {
    width: 280px;
    height: 68px;
    background: linear-gradient(270deg, #37a0ff 0%, rgba(67, 131, 235, 0.9) 100%);
    border-radius: 2px;
    /*变形*/
    transform: skew(-20deg);
  }
}
</style>
